(function () {
  if (customElements.get('trust-reviews')) return;

  class TrustReviews extends HTMLElement {
    constructor() {
      super();
      this.ratingElements = this.querySelectorAll('[data-rating]');
      this.countElements = this.querySelectorAll('[data-count]');

      this.update();
    }

    update() {
      //update ratings
      fetch(`https://judge.me/api/v1/widgets/all_reviews_rating?shop_domain=${window.Shopify.shop}&api_token=NXPjaYh817CKCJBO0rMnMooUvlg`)
        .then(response => response.json())
        .then(data => {
          this.ratingElements.forEach(element => {
            element.innerHTML = Number(data.all_reviews_rating).toFixed(1);
          });
          this.style.setProperty('--rating-perc', data.all_reviews_rating / 5 * 100 + '%');
        });

      // update count
      fetch(`https://judge.me/api/v1/widgets/all_reviews_count?shop_domain=${window.Shopify.shop}&api_token=NXPjaYh817CKCJBO0rMnMooUvlg`)
        .then(response => response.json())
        .then(data => {
          this.countElements.forEach(element => {
            element.innerHTML = data.all_reviews_count;
          });
        });
    }
  }

  customElements.define('trust-reviews', TrustReviews);
})()